import * as blogApi from 'Api/blog';
import { pickObjectsInArray, pickObject } from 'Utils/common';
import {
  SET_ALL,
} from './mutation-types';

export default {
  getBlogList({ commit, getters }) {
    if (getters.blogListLoaded) return Promise.resolve();
    commit(SET_ALL, { blogListLoading: true });
    return blogApi.getBlogList()
      .then(({ data }) => {
        const blogList = pickObjectsInArray(data.objects, [
          'id',
          'title',
          'slug',
          'featured_image',
          'page_title',
          'author_name',
          'freeze_date',
          'meta_description',
        ]);
        commit(SET_ALL, {
          blogList,
          blogListLoading: false,
        });
        return data;
      })
      .catch((error) => {
        commit(SET_ALL, { blogListLoading: false });
        throw error;
      });
  },
  getBlogData({ commit }, { slug }) {
    commit(SET_ALL, { blogDataLoading: true });
    return blogApi.getBlogData(slug)
      .then(({ data }) => {
        const blogData = pickObject(data.objects[0], [
          'author_name',
          'freeze_date',
          'page_title',
          'featured_image',
          'post_body',
          'id',
          'html_title',
          'meta_description',
        ]);
        commit(SET_ALL, {
          blogData,
          blogDataLoading: false,
        });
        return data;
      })
      .catch((error) => {
        commit(SET_ALL, { blogListLoading: false });
        throw error;
      });
  },
};
